import React, { useMemo } from 'react';

// Word-by-word reveal for headlines — reactbits' SplitText pattern, reusing
// the project's existing taglineReveal keyframe instead of the paid GSAP
// SplitText plugin.
export function SplitText({ text, className = '', wordClassName = '', delay = 0.06, startDelay = 0 }) {
  const words = useMemo(() => text.split(' '), [text]);

  return (
    <span className={className}>
      {words.map((word, i) => (
        <span
          key={`${word}-${i}`}
          className={`split-text-word ${wordClassName}`}
          style={{ animationDelay: `${startDelay + i * delay}s` }}
        >
          {word}
          {i < words.length - 1 ? ' ' : ''}
        </span>
      ))}
    </span>
  );
}
